import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import LocationListPage from './LocationListPage';
import './LocationListPage.less';

export const prefix = 'bm-p-brand-list';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: LocationListPage,
  routeProps: props,
  pageTitleI18nKey: '',
});

export default RouteComponent;
